import React, { FC } from 'react';
import { Container, UncontrolledTooltip  } from 'reactstrap';
import { FormBudgetDetailTableByProject, FormBudgetDetailTableByOnFFCC, FormBudgetDetailTableByOnFFRR, HeaderInformation } from '@components/';
import { IFormBudgetDetails } from '@interfaces/screens/form-budget-details.interface';
import { FormBudgetDetailPresenter } from '@presenters/screens/form-budget-detail.presenter';

export interface IFormBudgetDetailsProps {
    refGridNewTable: any;
}

const FormBudgetDetails: FC<any> = (props: IFormBudgetDetailsProps) => {

    const view: IFormBudgetDetails = {}
    const presenter = new FormBudgetDetailPresenter(view);

    return (
        <Container fluid={true}>
            <HeaderInformation
                data={presenter.headerInformation}
            ></HeaderInformation>
            {
                presenter.budgetOnBudget ?
                    <div>
                        <h3 id="ffccTitle">{presenter.ffccTitle}</h3>
                        <UncontrolledTooltip placement="right" target="ffccTitle">{presenter.toolTipFfccTitle}</UncontrolledTooltip>
                        <FormBudgetDetailTableByOnFFCC></FormBudgetDetailTableByOnFFCC>
                        <br/>
                        <h3 id="ffrrTitle">{presenter.ffrrTitle}</h3>
                        <UncontrolledTooltip placement="right" target="ffrrTitle">{presenter.toolTipFfrrTitle}</UncontrolledTooltip>
                        <FormBudgetDetailTableByOnFFRR></FormBudgetDetailTableByOnFFRR>
                    </div>
                    :
                    <FormBudgetDetailTableByProject></FormBudgetDetailTableByProject>
            }
        </Container> 
    )
}

export default FormBudgetDetails;